// DiemInput.tsx
import React, { useState } from 'react';
import { TextInput } from '@primer/react';

interface DiemInputProps {
  diem_toi_da: number;
  nhap_diem_chu: boolean;
  value: string | number;
  onValueChanged: (value: string | number) => void;
}

const DiemInput: React.FC<DiemInputProps> = ({
  diem_toi_da,
  nhap_diem_chu,
  value,
  onValueChanged,
}) => {
  const [localValue, setLocalValue] = useState(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
  };

  const handleBlur = () => {
    if (nhap_diem_chu) {
      onValueChanged(localValue);
      return;
    }

    const numValue = parseFloat(String(localValue));
    if (!isNaN(numValue) && numValue >= 0 && numValue <= diem_toi_da) {
      onValueChanged(numValue);
    } else {
      // Reset về giá trị ban đầu nếu giá trị không hợp lệ
      setLocalValue(value);
    }
  };

  return (
    <TextInput
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      type={nhap_diem_chu ? "text" : "number"}
      min={0}
      max={diem_toi_da}
      sx={{
        textAlign: 'center',
        '& input': {
          textAlign: 'center'
        }
      }}
    />
  );
};

export default DiemInput;